import { FC } from "react";
import classNames from "classnames";

import Skeleton from "../Skeleton/Skeleton";
import { HeaderDateSelectorProps } from "./types";
import DatePeriodSelector from "../DatePeriodSelector/DatePeriodSelector";
import { DateFilter, DateSelectionMode, OverviewPeriod } from "../DatePeriodSelector/types";
import { getHoursDiff } from "../HeaderBrandsSelector/utils/getHoursDiff";
import BrandWithCompetitorsSelect from "../BrandWithCompetitorsSelect/BrandWithCompetitorsSelect";
import { parseLocalDateString } from "../../store/utils/date/calendarDate";

import styles from "./HeaderDateSelector.module.css";



const HeaderDateSelector: FC<HeaderDateSelectorProps> = ({ 
  lastUpdateTime,
  className,
  onChange,
  selected,
  score,
  onBrandChange,
}) => {
  const hoursSinceLastUpdate = getHoursDiff(lastUpdateTime);


  const renderDatePicker = () => {
    if (!selected) return <Skeleton height={48} width={327} />;

    const parsed = parseLocalDateString(selected);
    const selectedDate = Number.isNaN(parsed.getTime()) ? new Date() : parsed;

    const handleDateFilterChange = (filter: DateFilter) => {
      if (filter.type !== DateSelectionMode.Date) return;
      onChange(filter.dateTs);
    };

    return (
      <div className={styles["header-prompts__select"]}>
        <DatePeriodSelector
          period={OverviewPeriod.OneDay}
          selectedDate={selectedDate}
          mode={DateSelectionMode.Date}
          isPeriodEnabled={false}
          onChange={handleDateFilterChange}
        />
      </div>
    );
  }

  const renderLabel = () => {
    if (hoursSinceLastUpdate === undefined || hoursSinceLastUpdate === null)
      return <Skeleton height={24} width={133} variant="text" />;

    return (
      <p>UPDATED {hoursSinceLastUpdate} H AGO</p>
    );
  }

  const renderInfo = () => {
    if (score === null) 
      return <Skeleton height={56} width={58.34} variant="text" />;

    if (score === undefined) 
      return <p className={styles["no-data"]}>No data</p>;
    
    return score;
  }

  return (
    <header className={classNames(styles["header-prompts"], className)}>
      <div className={styles["header-prompts__actions"]}>
        <div className={classNames(styles["header-prompts__select"], styles["select"])}>
          <BrandWithCompetitorsSelect onChange={onBrandChange} />
        </div>
        {renderDatePicker()}
      </div>

      <div className={styles["header-prompts__info"]}>
        <div className={styles["header-prompts__info-item"]}>
          <p>daily AI SCORE</p>
          {renderLabel()}
        </div>
        <div className={styles["header-prompts__value"]}>{renderInfo()}</div>
      </div>
    </header>
  );
};

export default HeaderDateSelector;
